<div class="detail-container">
    @if (propertyResource.isLoading()) {
    <property-skeleton />
    }  @else if (propertyResource.error()) {
        <error-card/>
    } @else {
        @if (propertyResource.value(); as deparment) {
            <div class="d-flex gap-4">
                <div>
                    <section-header>{{ deparment.name() }}</section-header>
                    <div class="d-flex flex-wrap gap-4">
                        <document-card
                            [style.view-transition-name]="'card-image'"
                            class="document-card">
                            @if (deparment.hasImageError()) {
                                <span class="text-center" card-content>{{deparment.name()}}</span>
                            } @else {
                                <img 
                                    card-content class="h-100" 
                                    (error)="deparment.handleImageError()" 
                                    [src]="deparment.thumbnailUrl()" alt="image" />
                            }
                            <span card-footer class="font-5">{{deparment.name()}}</span>
                        </document-card>
                    </div>
                </div>
            </div>

            <div class="mt-4">
                <section-header>Department Properties</section-header>

                <div class="masonry-columns">
                    @for (category of deparment.categories(); track $index) {
                        <property-card>
                            <span title>{{ category.name() }}</span>

                            <div
                                content
                                class="d-flex flex-column gap-3 primary-text">
                                <property-item-header />

                                @for (property of category.properties(); track $index) {
                                    <property-item-row
                                        [name]="property.name()"
                                        [value]="property.values()"></property-item-row>
                                }
                            </div>
                        </property-card>
                    } @empty {
                        <empty-property-card/>
                    }
                </div>
            </div>


            <div class="mt-4">
                <carousel [enableHover]="false" [dataSource]="deparment.documents()" class="carousel">
                    <span carousel-label>Department Documents ({{deparment.documents().length}})</span>
                </carousel>
            </div>

            <div class="my-6">
                <carousel [dataSource]="deparment.documents()" class="carousel-bottom-center carousel">
                    <span carousel-label>Rooms ({{deparment.documents().length}})</span>
                </carousel>
            </div>
        }
    }
</div>
